<template>
  <div class="sub-system">
    <pageTitle></pageTitle>
    <transition name="fade" mode="out-in">
      <div class="system bg-dark">
        <div class="system-setting ">

          <div class="setting-tab">
            <div class="tab-header">
              <div class="tab-header-item active">基本信息</div>
              <div class="tab-header-item">数据包规则</div>
              <div class="tab-header-item">握手包规则</div>
              <div class="tab-header-item">心跳包规则</div>
            </div>
            <div class="tab-body">
              <p>名称：温控</p>
              <p>连接超时时间：123</p>
              <p>系统简介：123</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="setting-tab">
            <div class="tab-header">
              <div class="tab-header-item active">协议列表</div>
              <div class="tab-header-item">事件列表</div>
            </div>
            <div class="tab-body">
              <div class="table-header">
                <div class="search input-group ">
                  <input type="text" class="form-control" placeholder="搜索">
                  <div class="input-group-append">
                    <span class="input-group-text"></span>
                  </div>
                </div>
                <button type="button" class="btn btn-success btn-sm">新增协议</button>
              </div>
              <div>
                <table class="table">
                  <thead>
                  <tr>
                    <th></th>
                    <th>协议名称</th>
                    <th>协议名称</th>
                    <th>协议名称</th>
                    <th>协议名称</th>
                    <th>协议名称</th>
                    <th>操作</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="one in 10">
                    <td>

                    </td>
                    <td>
                      名称
                    </td>
                    <td>
                      名称
                    </td>
                    <td>
                      名称
                    </td>
                    <td>
                      名称
                    </td>
                    <td>
                      名称
                    </td>
                    <td>
                      <button type="button" class="btn btn-primary btn-sm">编辑</button>
                      <button type="button" class="btn btn-danger btn-sm">删除</button>

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-bottom">
                <div>
                  <div class="form-check1">
                    <input type="checkbox">
                    <label class="form-check-label1">全选</label>
                    <button type="button" class="btn btn-danger btn-sm">删除</button>
                  </div>
                  <div>
                    <pagination></pagination>
                  </div>
                </div>

              </div>
            </div>
          </div>


        </div>
      </div>

    </transition>
  </div>
</template>

<script>
import pageTitle from "@/components/pageTitle";
import pagination from "@/components/pagination";

export default {
  name: "sub-system",
  components: {
    pageTitle
  },
  data() {
    return {
      cardType: "LIST",
      cmds: [],
      events: [],
      search: {}
    };
  },
  created() {
    this.loadCmds();
    this.loadEvents();
  },
  methods: {
    loadCmds() {
      let url = "cmds",
        params = {
          auth_token: "default",
          category_id: "5abcbaaeaa22fb6fe9fe5e29"
        };
      this.$http.get(url, { params }).then(data => {
        if (data.status_code === "SUCCEEDED") {
          this.cmds = data.payload;
        }
      });
    },
    deleteCmds(index) {
      let url = `cmds/${this.cmds[index].id}/destroy`,
        params = {
          auth_token: "default"
        };
      this.$http.delete(url, { params }).then(data => {
        if (this.data_status === "SUCCEEDED") {
          this.$message.success("操作成功");
        } else {
          this.$message.error(`操作失败${data.msg}`);
        }
      });
    },
    loadEvents() {
      let url = "events",
        params = {
          auth_token: "default",
          category_id: "5abcbaaeaa22fb6fe9fe5e29"
        };
      this.$http.get(url, { params }).then(data => {
        if (data.status_code === "SUCCEEDED") {
          this.cmds = data.payload;
        }
      });
    },
    deleteEvents() {
      let url ="events"
    }
  }
};
</script>
<style lang="scss" scoped>
.system {
  padding: 2rem;
  .setting-header {
    font-size: 1.2rem;
  }
  .tab-header {
    display: flex;
  }

  .tab-header-item {
    padding: 1rem 3rem;
    margin-right: 1rem;
    border-radius: 5px 5px 0px 0px;
    cursor: pointer;
  }
  .active {
    background: white;
    color: #1f2037;
  }
  .tab-body {
    padding: 1rem 1.6rem;
    border: 1px solid white;
    border-radius: 0px 5px 5px 5px;
  }

  .system-setting {
    margin-bottom: 2rem;
  }
  .list {
    .table-header {
      display: flex;
      margin: 1rem 0;
      justify-content: space-between;
      .search {
        width: 200px;
      }
    }
    .table {
      border-bottom: 1px solid #000;
    }
    .table-bottom {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/subSystem/subSystemList.vue